var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn btn-primary btn-icon",on:{"click":function($event){$event.stopPropagation();return _vm.clickHandler.apply(null, arguments)}}},[(_vm.loading)?_c('span',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div')]):_vm._e(),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }